import React, { useState, useEffect, Fragment } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Questions from 'components/installation/dynamicForm/questions';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DivLayout from 'components/sales/divLayout/divLayout';
import queryString from 'query-string';

const SiteInfo = ({
  gateInfo = null,
  data,
  handleValue,
  documentUploadUrl,
  documentUploadUrlPublic,
  match,
  formData,
  location,
  className,
  title,
  setIsValidMaterialData,
  isValidMaterialData,
  setHasMaterialData,
  hasMaterialData,
}) => {
  const [customCategory, setCustomCategory] = useState('');
  const [materialCategory, setMaterialCategory] = useState('');
  const [materials, setMaterial] = useState('');
  const [allQuestions, setallQuestions] = useState([]);
  const [materialQuestions, setmaterialQuestions] = useState([]);
  // const todayDate = new Date().toISOString().slice(0, 10);
  const [isTotalQntyValid, setIsTotalQntyValid] = useState('');
  const [materialData, setMaterialData] = useState({
    material_id: '',
    category_id: '',
    quantity: '',
  });

  useEffect(() => {
    if (materialData.material_id !== '') {
      if (materialQuestions && materialQuestions.length === 0) {
        materialQuestions.push(materialData);
        setmaterialQuestions([...materialQuestions]);
      } else {
        const isThere = materialQuestions.findIndex(
          (obj) => obj.material_id === materialData.material_id
        );
        if (isThere === -1) {
          materialQuestions.push(materialData);
          setmaterialQuestions([...materialQuestions]);
        } else {
          materialQuestions.splice(isThere, 1);
          materialQuestions.push(materialData);
          setmaterialQuestions([...materialQuestions]);
        }
      }
    }
  }, [materialData]);

  const totalCount = () => {
    let temp = 0;
    customCategory &&
      customCategory.map((obj) => {
        obj.questions && obj.questions.map((ele) => (temp += ele.required_count));
        // obj.questions && obj.questions.map((ele) => (temp += ele.types.length));
      });
    materialCategory &&
      materialCategory.map((obj) => {
        obj.questions && obj.questions.map((ele) => (temp += ele.required_count));
        // obj.questions && obj.questions.map((ele) => (temp += ele.types.length));
      });
    localStorage.setItem('count', temp);
  };

  useEffect(() => {
    if (data && data.custom_categories) {
      setCustomCategory(data.custom_categories);
    }
    if (data && data.material_categories) {
      setMaterialCategory(data.material_categories);
    }
    if (data && data.materials) {
      setMaterial(data.materials);
    }
  }, [data]);

  const handleQuestion = (val) => {
    if (val !== undefined && val !== null) {
      if (allQuestions && allQuestions.length === 0) {
        allQuestions.push(val);
        setallQuestions([...allQuestions].filter(q => q !== undefined && q !== null && q !== ''));
      } else {
        const isThere = allQuestions.findIndex((obj) => obj.id === val.id);
        if (isThere === -1) {
          allQuestions.push(val);
          setallQuestions([...allQuestions].filter(q => q !== undefined && q !== null && q !== ''));
        } else {
          allQuestions.splice(isThere, 1);
          allQuestions.push(val);
          setallQuestions([...allQuestions].filter(q => q !== undefined && q !== null && q !== ''));
        }
      }
    }
  };

  useEffect(() => {
    totalCount();
    if (materials && materials.length) {
      if (allQuestions.length > 0 && materialQuestions.length > 0) {
        handleValue({
          site_id: match.params.id,
          gate_id:
            location?.state?.gateId ||
            queryString.parse(location.search)?.gateId,
          schedule_id: match.params.stageId,
          checklist_answers: allQuestions,
          handover_hardware_material: materialQuestions,
        });
      }
    } else {
      if (allQuestions.length > 0) {
        handleValue({
          site_id: match.params.id,
          gate_id:
            location.state?.gateId ||
            queryString.parse(location.search)?.gateId,
          schedule_id: match.params.stageId,
          checklist_answers: allQuestions,
        });
      }
    }
  }, [allQuestions, materialData]);

  return (
    <Fragment>
      {gateInfo !== null && (
        <FormSection title={localization.gateDetails}>
          <div className="details-listing">
            <DivLayout
              heading={localization.siteNumber}
              gate_no
              data={gateInfo && gateInfo.sites && gateInfo.sites.site_no}
            />
            <DivLayout
              heading={localization.gateNumber}
              data={gateInfo && gateInfo.gates && gateInfo.gates[0].gate_no}
            />
            <DivLayout
              heading={localization.gateType}
              data={gateInfo && gateInfo.gates && gateInfo.gates[0].used_for}
            />
            <DivLayout
              heading={localization.gateName}
              data={gateInfo && gateInfo.gates && gateInfo.gates[0].gateName}
            />
          </div>
        </FormSection>
      )}
      <div>
        <div className="panel-heading">
          {title ? title : localization.formDetails}
        </div>
        {customCategory !== '' && (
          <Questions
            data={customCategory}
            formDatas={formData}
            handleValue={handleQuestion}
            documentUploadUrl={documentUploadUrl}
            documentUploadUrlPublic={documentUploadUrlPublic}
            className={className}
          />
        )}

        {materialCategory !== '' && (
          <Questions
            data={materialCategory}
            formDatas={formData}
            handleValue={handleQuestion}
            documentUploadUrl={documentUploadUrl}
            documentUploadUrlPublic={documentUploadUrlPublic}
            className={className}
          />
        )}
        {materials && materials.length && (
          <FormSection title={localization.material}>
            <div className="panel-body">
              <table className="panel-table faq-listing">
                <thead>
                  <tr>
                    <th>{localization.categoryName}</th>
                    <th>{localization.material}</th>
                    <th>{localization.quantity}</th>
                    <th>{localization.quantityAllocated}</th>
                  </tr>
                </thead>
                <tbody>
                  {materials &&
                    materials.length > 0 &&
                    materials.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td>{obj.category_name}</td>
                          <td>{obj.material_name}</td>
                          <td>{obj.total_quantity}</td>
                          <td>
                            <ConstantInput
                              required
                              isStarRequired={true}
                              type="number"
                              min={0}
                              max={obj.total_quantity}
                              errorMsg={localization.isRequired}
                              handleChange={(val) => {
                                setMaterialData({
                                  ...materialData,
                                  quantity: val,
                                  material_id: obj.material_id,
                                  category_id: obj.category_id,
                                });
                                if (
                                  Number(val) >= 0 &&
                                  Number(val) <= Number(obj.total_quantity)
                                ) {
                                  delete isValidMaterialData[index];
                                  setIsValidMaterialData({
                                    ...isValidMaterialData,
                                  });
                                  delete hasMaterialData[index];
                                  setHasMaterialData({
                                    ...hasMaterialData,
                                  });
                                } else {
                                  setIsValidMaterialData({
                                    ...isValidMaterialData,
                                    [index]:
                                      'Quantity Allocated should be less than and equal to Quantity and more than Zero.',
                                  });
                                  setHasMaterialData({
                                    ...hasMaterialData,
                                    [index]: true,
                                  });
                                }
                                if (val === '') {
                                  setHasMaterialData({
                                    ...hasMaterialData,
                                    [index]: true,
                                  });
                                }
                              }}
                            />
                            {isValidMaterialData[index] && (
                              <label className={`error d-block`}>
                                {isValidMaterialData[index]}
                              </label>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </FormSection>
        )}
      </div>
    </Fragment>
  );
};

export default SiteInfo;
